import getTimezoneOffset from "get-timezone-offset"

export const germanTimeZone = "Europe/Berlin"
export const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

export const germanTimeZoneOffsetMinutes = getTimezoneOffset(germanTimeZone)
export const localTimeZoneOffsetMinutes = safeGetTimezoneOffset(localTimeZone)

export const localTimeZoneOffsetHours = safeGetTimezoneOffset(localTimeZone) / 60
export const germanTimeZoneOffsetHours = safeGetTimezoneOffset(germanTimeZone) / 60

export const germanTimeOffsetIso = `+${(-germanTimeZoneOffsetHours).toString().padStart(2, "0")}:00` as const
export const germanDateTemplate = `0001-01-01T00:00:00.000${germanTimeOffsetIso}` as const

function validateIso(input: string) {
  if (input.length < 4) {
    throw new Error("The input is too short: " + input)
  }
  if (input.length > 4 && !input.includes("-")) {
    throw new Error("The input does not seem to be in ISO format: " + input)
  }
}

function padDate(input: string) {
  if (input.endsWith("Z") || input.includes("+")) {
    return input
  }
  return input + germanDateTemplate.slice(input.length)
}

export function interpretAsGermanTimeIso(input: string) {
  validateIso(input)

  let result = input
  if (result.endsWith("Z")) {
    result = result.slice(0, -1)
  }
  if (result.includes("+")) {
    result = result.split("+")[0]!
  }

  return padDate(result)
}

export function safeGetTimezoneOffset(timeZone: string) {
  try {
    return getTimezoneOffset(timeZone)
  } catch (error) {
    // e.g. Invalid time zone specified: Etc/Unknown
    console.error(error)

    // Most customers are from Germany, so defaulting to German timezone makes most sense.
    return germanTimeZoneOffsetMinutes
  }
}

function getOffsetToGermanyMilliseconds() {
  return getOffsetToGermanyMinutes() * 60_000
}

function getOffsetToGermanyMinutes() {
  return localTimeZoneOffsetMinutes - germanTimeZoneOffsetMinutes
}

function getOffsetToGermanyHours() {
  return getOffsetToGermanyMinutes() / 60
}

export function getDateInGermanyIso(input: string) {
  validateIso(input)

  const referenceDate = new Date(padDate(input))

  const offsetMinutes = germanTimeZoneOffsetMinutes
  const offsetMilliseconds = offsetMinutes * 60_000
  const referenceMillis = referenceDate.getTime()
  const relativeMillis = referenceMillis - offsetMilliseconds
  const offsetDate = new Date(relativeMillis)
  const germanDateIso = offsetDate.toISOString().slice(0, -1) + germanTimeOffsetIso

  return germanDateIso
}

export function getDateInGermany(input: string) {
  return new Date(getDateInGermanyIso(input))
}

export function getNowInGermanyIso() {
  return getDateInGermanyIso(new Date().toISOString())
}

export function getNowInGermany() {
  return new Date(getNowInGermanyIso())
}

export function getEndOfDateInGermany(input: string) {
  validateIso(input)

  const germanDateIso =
    new Date(padDate(input)).toISOString().slice(0, "0000-00-00".length) + "T23:59:59.999" + germanTimeOffsetIso

  return new Date(germanDateIso)
}

export function getEndOfDayInGermany() {
  return getEndOfDateInGermany(new Date().toISOString())
}
